import React, { useMemo } from 'react'

import { SxProps } from '@mui/material'

import { IEntityTerminology } from 'types/GlobalEntities'

import { useEntityActions } from 'redux/actions/Entities'
import { useEntity } from 'redux/hooks/Entities'
import { useParams, useQuery } from 'utils/hooks'

import InputTable, { InputTableRow } from 'components_new/molecules/InputTable'

interface Props {
  sx?: SxProps
}

interface TableRow extends InputTableRow {
  definitions: IEntityTerminology['definitions']
}

const EntityTerminology = React.memo((props: Props) => {
  const { sx } = props
  const { id } = useParams<{ id: string }>()

  const { tryPutTerminology } = useEntityActions()

  const entity = useEntity(id)
  const { query } = useQuery()

  const edit = Boolean(query['edit'])

  const handleChange = (term: TableRow, name: string) => {
    const data = term.definitions.map((def) => ({ ...def, name }))

    tryPutTerminology(data, id)
  }

  const rows = useMemo(
    () =>
      entity?.terminology.map(
        (term): TableRow => ({
          definitions: term.definitions,
          id: term.id,
          input: {
            value: term.title.custom
          },
          title: term.title.standard
        })
      ) || [],
    [entity?.terminology]
  )

  if (!entity) {
    return null
  }

  // success
  return (
    <InputTable<TableRow>
      edit={edit}
      onChange={handleChange}
      rows={rows}
      sx={sx}
    />
  )
})

export default EntityTerminology
